import type { CSSProperties } from "react";

export const BRAND = "#0F9599";
export const BRAND_DARK = "#0F6E56";
export const TEXT_PRIMARY = "#111827";
export const TEXT_INK = "#1A2B2B";
export const TEXT_SECONDARY = "#6B7280";
export const TEXT_TERTIARY = "#9CA3AF";
export const BG_CARD = "#FFFFFF";
export const BG_PAGE = "#F7F9F9";
export const BORDER = "#E5E7EB";
export const BORDER_LIGHT = "#F0F4F4";

export const BTN_TEAL: CSSProperties = {
  background: BRAND,
  color: "white",
  fontSize: 14,
  fontWeight: 600,
  padding: "10px 18px",
  border: "none",
  borderRadius: 9,
  cursor: "pointer",
  fontFamily: "inherit",
};

export const BTN_TEAL_OUT: CSSProperties = {
  background: BG_CARD,
  color: BRAND_DARK,
  fontSize: 13.5,
  fontWeight: 600,
  padding: "9px 14px",
  border: "0.5px solid " + BRAND,
  borderRadius: 9,
  cursor: "pointer",
  fontFamily: "inherit",
  display: "inline-flex",
  alignItems: "center",
  gap: 7,
};

export const BTN_OUT: CSSProperties = {
  background: BG_CARD,
  color: TEXT_PRIMARY,
  fontSize: 13.5,
  fontWeight: 600,
  padding: "9px 14px",
  border: "0.5px solid " + BORDER,
  borderRadius: 9,
  cursor: "pointer",
  fontFamily: "inherit",
};

export const BTN_GHOST: CSSProperties = {
  background: "transparent",
  color: TEXT_SECONDARY,
  fontSize: 13.5,
  fontWeight: 600,
  padding: "9px 14px",
  border: "none",
  borderRadius: 9,
  cursor: "pointer",
  fontFamily: "inherit",
};

export const ICON_BTN: CSSProperties = {
  width: 34,
  height: 34,
  display: "grid",
  placeItems: "center",
  borderRadius: 8,
  color: TEXT_SECONDARY,
  cursor: "pointer",
};

export const LINK: CSSProperties = {
  color: BRAND_DARK,
  fontSize: 13,
  fontWeight: 600,
  cursor: "pointer",
};

export const BADGE_PRIMARY: CSSProperties = {
  display: "inline-block",
  background: BRAND,
  color: "white",
  fontSize: 10.5,
  fontWeight: 700,
  letterSpacing: "0.05em",
  padding: "3px 9px",
  borderRadius: 6,
};